<div class="relative w-full">
  <!-- Selected values -->
  <div
    class="border border-gray-300 rounded-md px-3 py-2 w-full cursor-pointer bg-white"
    (click)="toggleDropdown()"
  >
    <div class="flex flex-wrap gap-2 min-h-[24px]">
      @for (val of selectedValues; track $index) {
      <span
        class="flex items-center text-primary border border-primary text-xs px-2 py-1 rounded-full"
      >
        {{ getLabel(val) }}
        <button
          class="ml-1 text-primary hover:text-red-500 font-bold"
          (click)="remove(val); $event.stopPropagation()"
        >
          ×
        </button>
      </span>
      } @if (selectedValues.length === 0) {
      <span class="text-gray-400 text-sm">
        {{ placeholder }}
      </span>
      }
    </div>
  </div>

  <!-- Dropdown -->
  @if (isOpen) {
  <div
    class="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md max-h-60 overflow-auto shadow-md"
  >
    @for (option of options; track $index) {
    <div
      (click)="toggleSelection(option); $event.stopPropagation()"
      [class.bg-secondary]="isSelected(option.value)"
      class="px-4 py-2 hover:bg-secondary cursor-pointer text-sm"
    >
      <input
        type="checkbox"
        class="mr-2 accent-primary"
        [checked]="isSelected(option.value)"
        readonly
      />
      {{ option.label }}
    </div>
    }
  </div>
  }
</div>
